"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _NavBar = require("./NavBar");
Object.keys(_NavBar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NavBar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NavBar[key];
    }
  });
});